import { useEffect } from "react";
import Nav from "@/components/sections/Nav";
import Hero from "@/components/sections/Hero";
import BrandMarquee from "@/components/sections/BrandMarquee";
import FeaturedProject from "@/components/sections/FeaturedProject";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import Bonsai from "@/components/sections/Bonsai";
import Instagram from "@/components/sections/Instagram";
import JournalTeaser from "@/components/sections/JournalTeaser";
import FAQ from "@/components/sections/FAQ";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

export default function Home() {
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll(".reveal").forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <main data-testid="home-page" className="bg-[#F9F8F6] text-[#2D332B]">
      <Nav />
      <Hero />
      <BrandMarquee />
      <FeaturedProject />
      <About />
      <Services />
      <Bonsai />
      <Instagram />
      <JournalTeaser />
      <FAQ />
      <Contact />
      <Footer />
    </main>
  );
}
